<template>
    <el-form v-if="model"
             ref="form"
             :model="model"

    >
        <el-form-item  label="规则名称"  >
            <span >{{model.rule_name}}</span>
        </el-form-item>
        <el-form-item  label="适用成员">
            <el-select v-model="model.allow_range" filterable multiple placeholder="请选择" style="width:80%">
                <el-option
                        v-for="item in users"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                >
                </el-option>
            </el-select>
        </el-form-item>
        <el-alert v-if="model.type==1" title=" 业务员有区域保护的客户不会执行自动解绑" type="info" :closable="false" style="margin-left:8%;width: 640px"></el-alert>
        <hr color="#FFFFF"/>

        <el-form-item v-if="model.type==1"  label="自动解绑规则">
            超过N天“未跟进”的非正式客户，由系统定时解绑至客户公海池
            <template>
                <el-table
                        :data="tableData"
                        style="margin-left:10%;"
                        >
                    <el-table-column
                            prop="client"
                            label="客户"
                            width="180">
                    </el-table-column>
                    <el-table-column
                            prop="start_day"
                            label="绑定后未跟进天数"
                            width="180">
                        <template slot-scope="scope">
                            <el-form-item>
                                超过<el-input v-model="model.start_day"  style="width: 55px"></el-input>天未跟进
                            </el-form-item>
                            
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="end_day"
                            label="未再次跟进天数"
                            width="180">
                        <template slot-scope="scope">
                            <el-form-item>
                                超过<el-input v-model="model.end_day"  style="width: 55px"></el-input>天未跟进
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="unbound1"
                            label="解绑至客户公海池时间"
                            width="180">
                    </el-table-column>
                </el-table>
            </template>
            <el-form-item>
                <el-button type="primary" style="margin-top: 30px;margin-left: 70px" @click="submitForm()">立即保存</el-button>
            </el-form-item>
        </el-form-item>

        <el-form-item v-if="model.type==2"  label="绑定天数设置">
            单个业务员绑定单个客户时间超出最大期限时自动解绑，且不可再被绑定。业务员开通正式订单后从到期日起重新计算绑定时长。
            <template>
                <el-table
                        :data="tableData"
                        style="margin-left:10%;">
                    <el-table-column
                            prop="client"
                            label="客户"
                            width="180">
                    </el-table-column>
                    <el-table-column
                            prop="start_day"
                            label="未成交客户"
                            width="250">
                        <template slot-scope="scope">累计绑定超过
                            <el-input v-model="scope.row.start_day" @change="changeStartDay(scope.row.start_day)" style="width: 100px"></el-input>天
                        </template>

                    </el-table-column>
                    <el-table-column
                            prop="end_day"
                            label="非排课成交客户"
                            width="250">
                        <template slot-scope="scope">全部断续超
                            <el-input v-model="scope.row.end_day" @change="changeEndDay(scope.row.end_day)" style="width: 100px"></el-input>天
                        </template>

                    </el-table-column>
                    <el-table-column
                            prop="unbound2"
                            label="解绑至客户公海池时间"
                            style="width: 100px">
                    </el-table-column>
                </el-table>
            </template>
            <el-form-item>
                <el-button type="primary" style="margin-top: 30px;margin-left: 70px" @click="submitForm()">立即保存</el-button>
            </el-form-item>
        </el-form-item>
        <el-form-item v-if="model.type==4 || model.type==5"  label="规则说明">
            {{model.rule_type}}
            <el-form-item>
                <el-button type="primary" style="margin-top: 30px;margin-left: 70px" @click="submitForm()">立即保存</el-button>
            </el-form-item>
        </el-form-item>

        <el-form-item v-if="model.type==6"  label="绑定天数设置">
            业务员有区域保护的线索不会执行自动解绑
            <el-table
                    :data="tableData6"
                    style="margin-left:10%;">
                <el-table-column
                        prop="client"
                        label="线索"
                        width="180">
                </el-table-column>
                <el-table-column
                        prop="expire_time"
                        label="绑定后未关联客户时长"
                        width="250">
                </el-table-column>
                <el-table-column
                        prop="memo"
                        label="解绑重新轮流分配"
                        style="width: 100px">
                </el-table-column>
            </el-table>
            <el-form-item>
                <el-button type="primary" style="margin-top: 30px;margin-left: 70px" @click="submitForm()">立即保存</el-button>
            </el-form-item>
        </el-form-item>


        <el-form-item v-if="model.type==7"  label="绑定天数设置">
            业务员有区域保护的线索不会执行自动解绑
            <el-table
                    :data="tableData7"
                    style="margin-left:10%;">
                <el-table-column
                        prop="client"
                        label="客户"
                        width="180">
                </el-table-column>
                <el-table-column
                        prop="first_expire_time"
                        label="绑定后未跟进天数"
                        width="250">
                        <template slot-scope="scope">
                            <el-form-item>
                                超过<el-input v-model="model.start_day"  style="width: 55px"></el-input>天未跟进
                            </el-form-item>
                            
                        </template>
                </el-table-column>
                <el-table-column
                        prop="last_expire_time"
                        label="未再次未跟进天数"
                        width="250">
                        <template slot-scope="scope">
                            <el-form-item>
                                超过<el-input v-model="model.end_day"  style="width: 55px"></el-input>天未跟进
                            </el-form-item>
                        </template>
                </el-table-column>
                <el-table-column
                        prop="memo"
                        label="解绑至公海池时间"
                        style="width: 100px">
                </el-table-column>
            </el-table>
            <el-form-item>
                <el-button type="primary" style="margin-top: 30px;margin-left: 70px" @click="submitForm()">立即保存</el-button>
            </el-form-item>
        </el-form-item>
    </el-form>
</template>

<script>
    import UserService from "~/services/user";
    import Rule from "~/services/Rule";

    export default {
        name: "ruleForm",
        props: {
            model: {
                type: Object,
                required: true
            },
            scenario: {
                type: String,
                required: true
            }
        },
        data() {

            return {
                labelPosition: 'top',
                users: [],
                start_day:this.model.start_day,
                end_day:this.model.end_day,
                allow_types: {},
                tableData:[{
                    "start_day": this.model.start_day,
                    "end_day": this.model.end_day,
                    "client" : '所有客户',
                    "unbound2" : '系统会在次日的05:00:00将超过累计绑定天数的客户自动解绑',
                    "unbound1" : '系统会在次日的05:00:00将超时未跟进的客户解绑至公海池'
                }],
                tableData6:[{
                    "client" : '所有线索',
                    "expire_time" : '绑定当天未关联客户',
                    "memo" : '系统将在次日12：00点解绑线索并重新在用户组间开始轮流分配'
                }],
                tableData7:[{
                    "client" : '超时未成交客户',
                    "first_expire_time" : this.model.start_day,
                    "last_expire_time" : this.model.end_day,
                    "memo" : '系统将在次日05：00点将超时未成交客户解绑至公海池'
                }]
            };
        },

        created() {
            if (this.model.id > 0) {
                this.getSelectOptions()
                if (this.model.allow_times) {
                    for (var i in this.model.allow_times) {
                        this.checkedTimes.push(i);
                    }
                }
            }
        },

        methods: {
            submitForm() {
                this.$refs["form"].validate(valid => {
                    if (valid) {
                       if (this.scenario == 'update' && this.model.id > 0) {
                            Rule.update({
                                allow_uids: this.model.allow_range,
                                start_day: this.start_day,
                                end_day: this.end_day,
                                type:this.model.type,
                                id:this.model.id
                       }).then(res => {
                                if (res.code == 0) {
                                    this.$message.success('更新成功!');
                                    this.$router.push({path: "/login-rules/rule-index"});//, query: {type: this.model.type}
                                }
                            })
                        }

                        return true;
                    } else {
                        return false;
                    }
                })

            },
            getSelectOptions() {
                UserService.getAll({
                    fields: "id,name",
                    scenario: "all-user"
                }).then(res => {
                    if (res.code == 0) {
                        this.users = Array.isArray(res.data)
                            ? res.data.map(item => ({
                                ...item,
                                id: Number(item.id)
                            }))
                            : []
                    }
                })

            },
            changeStartDay(day){
                this.start_day = day;
                return true;
            },
            changeEndDay(day){
                this.end_day = day;
                return true;
            }


        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/login-rules/ruleForm.vue